export const endpoints = {
  recaptcha: {
    verify: '/recaptcha/verify',
  },
  auth: {
    me: '/authentication/me',
    login: '/authentication/login',
    register: '/authentication/register',
    getUserByCode: (code: string) => `/authentication/user-by-code/${code}`,
    completeInvitation: '/authentication/complete-invitation',
    logout: '/authentication/logout',
    resendVerifyEmail: '/authentication/resend-verify-email',
    confirmRegister: (code: string) => `/authentication/confirm-register/${code}`,
    checkConfirmRegister: '/authentication/check-confirm-register',
    forgotPassword: '/authentication/forgot-password',
    resetPassword: '/authentication/reset-password',
  },
  dashboard: {
    overview: '/dashboard',
    saveColor: '/savecolor',
    graphs: '/graphs',
    chartExpenses: (environmentId: string | number) => `/dashboard/chart-expenses/${environmentId}`,
  },
  reports: {
    getAll: (environmentId: number) => `/reports/${environmentId}/all`,
    get: (id: number | string) => `/reports/${id}`,
    getUserReports: (id: number | string, environmentId: string | number) =>
      `/environments/${environmentId}/users/${id}/reports`,
    getFees: (id: number | string) => `/reports/${id}/fees`,
    accept: (id: number | string) => `/reports/${id}/accept`,
    reject: (id: number | string) => `/reports/${id}/reject`,
    delete: (id: number | string) => `/reports/${id}`,
    acceptFee: (reportId: number | string, feeId: number | string) =>
      `/reports/${reportId}/fees/${feeId}/accept`,
    rejectFee: (reportId: number | string, feeId: number | string) =>
      `/reports/${reportId}/fees/${feeId}/reject`,
    pdf: (reportId: number | string) => `/reports/${reportId}/pdf`,
  },
  users: {
    getUser: (id: number | string) => `/users/${id}`,
    updateUser: (id: number | string) => `/users/${id}`,
    getAll: `/users`,
    addUser: `/users`,
    deleteUser: (userId: number | string) => `/users/${userId}`,
  },
  environments: {
    getEnvironment: (id: number | string) => `/environments/${id}`,
    getAll: '/environments',
    create: '/environments',
    updateEnvironment: (id: number | string) => `/environments/${id}`,
    updateEnvironmentLogo: (id: number | string) => `/environments/${id}/logo`,
    delete: (id: number | string) => `/environments/${id}`,
    changeAdmin: (id: number | string) => `/environments/${id}/change-admin`,
    assignLicenses: (id: number | string) => `/environments/${id}/assign-licenses`,
  },
  currencies: {
    getCurrency: (id: number | string) => `/currencies/${id}`,
    getAll: '/currencies',
  },
  categories: {
    create: (environmentId: number | string) => `/environments/${environmentId}/categories`,
    getCategory: (id: number | string) => `/categories/${id}`,
    updateCategory: (id: number | string) => `/categories/${id}`,
    getAll: (environmentId: number | string) => `/environments/${environmentId}/categories`,
    delete: (id: number | string) => `/categories/${id}`,
    getTags: (id: number | string) => `/categories/${id}/tags`,
  },
  tags: {
    getTag: (id: number | string) => `/tags/${id}`,
    getAll: (environmentId: number | string) => `/environments/${environmentId}/tags`,
    create: (environmentId: number | string) => `/environments/${environmentId}/tags`,
    updateTag: (id: number | string) => `/tags/${id}`,
    delete: (id: number | string) => `/tags/${id}`,
  },
  jobOrders: {
    getJobOrder: (id: number | string) => `/job-orders/${id}`,
    getAll: (environmentId: number | string) => `/environments/${environmentId}/job-orders`,
    create: (environmentId: number | string) => `/environments/${environmentId}/job-orders`,
    updateJobOrder: (id: number | string) => `/job-orders/${id}`,
    delete: (id: number | string) => `/job-orders/${id}`,
  },
  clients: {
    getClient: (id: number | string) => `/clients/${id}`,
    getAll: (environmentId: number | string) => `/environments/${environmentId}/clients`,
    create: (environmentId: number | string) => `/environments/${environmentId}/clients`,
    updateClient: (id: number | string) => `/clients/${id}`,
    delete: (id: number | string) => `/clients/${id}`,
  },
  costCenters: {
    getCostCenter: (id: number | string) => `/cost-centers/${id}`,
    getAll: (environmentId: string | number) => `environments/${environmentId}/cost-centers`,
    create: (environmentId: string | number) => `environments/${environmentId}/cost-centers`,
    updateCostCenter: (id: number | string) => `/cost-centers/${id}`,
    delete: (id: number | string) => `/cost-centers/${id}`,
  },
  subscriptions: {
    getSubscriptions: `/subscriptions`,
    getCheckoutUri: (subscriptionId: string) => `/subscriptions/${subscriptionId}/checkout-uri`,
    getChangePaymentMethodUri: (subscriptionId: string) =>
      `/subscriptions/${subscriptionId}/change-payment-method-uri`,
  },
  profile: {
    updateProfile: '/profile',
    changePassword: '/profile/change-password',
  },
  instruments: {
    get: (id: number | string) => `/instruments/${id}`,
    getAll: `/instruments`,
    create: `/instruments`,
    update: (id: number | string) => `/instruments/${id}`,
    delete: (id: number | string) => `/instruments/${id}`,
  },
  measurements: {
    get: (id: number | string) => `/measurements/${id}`,
    getAll: `/measurements`,
    create: `/measurements`,
    update: (id: number | string) => `/measurements/${id}`,
    close: (id: number | string) => `/measurements/${id}/close`,
    delete: (id: number | string) => `/measurements/${id}`,
  },
  certifications: {
    get: (id: number | string) => `/certifications/${id}`,
    getAll: `/certifications`,
    create: `/certifications`,
    update: (id: number | string) => `/certifications/${id}`,
    delete: (id: number | string) => `/certifications/${id}`,
  },
  yards: {
    get: (id: number | string) => `/yards/${id}`,
    getAll: `/yards`,
    create: `/yards`,
    update: (id: number | string) => `/yards/${id}`,
    delete: (id: number | string) => `/yards/${id}`,
  },
  logs: {
    get: (id: number | string) => `/logs/${id}`,
    getAll: `/logs`,
    create: `/logs`,
    update: (id: number | string) => `/logs/${id}`,
    delete: (id: number | string) => `/logs/${id}`,
  },
  qualityReport: {
    generate: `/quality-report`,
  },
  configuration: {
    template: `/configuration/template`,
    templateDownload: `/configuration/template/download`,
  },
};
